const SELECTOR = 'cart-volume-pricing';

function closeAllVolumePricingPopovers(except) {
  document.querySelectorAll(SELECTOR).forEach((component) => {
    if (component === except) return;

    const toggle = component.querySelector('[data-cart-volume-pricing-toggle]');
    const panel = component.querySelector('[data-volume-pricing-popover]');
    toggle?.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
  });
}

class CartVolumePricing extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-cart-volume-pricing-toggle]');
    this.popoverPanel = this.querySelector('[data-volume-pricing-popover]');
    if (!this.toggle || !this.popoverPanel) return;

    this.onToggleClick = this.onToggleClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.toggle.addEventListener('click', this.onToggleClick);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.onToggleClick);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  onToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const isOpen = this.toggle.getAttribute('aria-expanded') === 'true';
    closeAllVolumePricingPopovers(this); 

    if (!isOpen) {
      this.toggle.setAttribute('aria-expanded', 'true');
      this.popoverPanel.hidden = false;
    }
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.toggle.setAttribute('aria-expanded', 'false');
      this.popoverPanel.hidden = true;
    }
  }

  onKeydown(event) {
    if (event.key !== 'Escape') return;

    if (this.toggle.getAttribute('aria-expanded') === 'true') {
      this.toggle.setAttribute('aria-expanded', 'false');
      this.popoverPanel.hidden = true;
      this.toggle.focus();
    }
  }
}

if (!customElements.get(SELECTOR)) {
  customElements.define(SELECTOR, CartVolumePricing);
}
